import { lazy } from 'react';
const SalesRt = lazy(() => import('./SalesRt'));

const SalesRtRoutes = [
  {
    path: '/salesrt',
    component: SalesRt
  }
];

export default SalesRtRoutes;
